import { Injectable } from '@angular/core';
import {catchError, retry} from 'rxjs/operators';
import {throwError as observableThrowError} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';



@Injectable({
  providedIn: 'root'
})
export class RestService {

  public serverURL = environment.API_URL;

  constructor(
    private http: HttpClient,
  ) { }


  public requestAllowAnonymousGET(link) {
    return this.http.get(link)
      .pipe(
        retry(0),
        catchError(this.handleError)
      );
  }

  public requestPOSTX(link, body) {
    return this.http.post(link, body);
      // .pipe(
      //   // retry(0),
      //   // catchError(this.handleError)
      // );
  }

  public requestAllowAnonymousPOST(link, body) {
    return this.http.post(link, body);
  }

  private handleError(error: HttpErrorResponse) {

    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // alert('hello');
      //
      if (error.status === 410) {
        // localStorage.removeItem('currentUser');
        // localStorage.removeItem('profile');
        // this.user = {};
        // this.profile = {};
        // window.location.replace('/login');
        //



      }
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error.ResultMessages[0].Message}`);
    }

    // return an ErrorObservable with a user-facing error message
    return observableThrowError(
      error.error.error);
  }

}
